<template>
  <div id="modalCreateEditClient" class="modal fade" tabindex="-1">
    <div class="modal-dialog modal-full">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ textModal }} Cliente</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            title="Fechar"
            @click="$emit('closeModal', false)"
          />
        </div>
        <form @submit.prevent="save">
          <div class="modal-body">
            <div class="row g-3">
              <div class="col-lg-2 col-md-6">
                <label class="form-label">
                  Código: <span class="text-danger">*</span>
                </label>
                <input
                  type="text"
                  class="form-control"
                  :class="{ 'is-invalid': v$.client.codCliente.$errors.length }"
                  placeholder="Código do Cliente"
                  v-model="v$.client.codCliente.$model"
                />
                <span
                  v-if="
                    v$.client.codCliente.required.$invalid &&
                    v$.client.codCliente.$errors.length
                  "
                  class="invalid-feedback"
                >
                  O campo é obrigatório
                </span>
              </div>
              <div class="col-lg-2 col-md-6">
                <label class="form-label">
                  Código do Projeto: <span class="text-danger">*</span>
                </label>
                <input
                  type="text"
                  class="form-control"
                  :class="{ 'is-invalid': v$.client.codProjeto.$errors.length }"
                  placeholder="Código do Projeto"
                  v-model="v$.client.codProjeto.$model"
                />
                <span
                  v-if="
                    v$.client.codProjeto.required.$invalid &&
                    v$.client.codProjeto.$errors.length
                  "
                  class="invalid-feedback"
                >
                  O campo é obrigatório
                </span>
              </div>
              <div class="col-lg-6 col-md-6">
                <label class="form-label">
                  Nome: <span class="text-danger">*</span>
                </label>
                <input
                  type="text"
                  class="form-control"
                  :class="{ 'is-invalid': v$.client.nome.$errors.length }"
                  placeholder="Nome do Cliente"
                  v-model="v$.client.nome.$model"
                />
                <span
                  v-if="
                    v$.client.nome.required.$invalid &&
                    v$.client.nome.$errors.length
                  "
                  class="invalid-feedback"
                >
                  O campo é obrigatório
                </span>
              </div>
              <div class="col-lg-2 col-md-6">
                <label class="form-label">
                  Status: <span class="text-danger">*</span>
                </label>
                <select class="form-select" v-model="v$.client.status.$model">
                  <option value="" disabled>Selecione</option>
                  <option
                    v-for="option in optionsStatus"
                    :key="option.value"
                    :value="option.value"
                  >
                    {{ option.text }}
                  </option>
                </select>
              </div>
              <div class="col-lg-8 col-md-12">
                <label class="form-label">
                  Descrição: <span class="text-danger">*</span>
                </label>
                <input
                  type="text"
                  class="form-control"
                  :class="{ 'is-invalid': v$.client.descricao.$errors.length }"
                  placeholder="Descrição do Cliente"
                  v-model="v$.client.descricao.$model"
                />
                <span
                  v-if="
                    v$.client.descricao.required.$invalid &&
                    v$.client.descricao.$errors.length
                  "
                  class="invalid-feedback"
                >
                  O campo é obrigatório
                </span>
              </div>
              <div class="col-lg-4 col-md-6">
                <label class="form-label">
                  Atribuir Tickets Automaticamente:
                  <span class="text-danger">*</span>
                </label>
                <select class="form-select" v-model="v$.client.default.$model">
                  <option value="" disabled>Selecione</option>
                  <option
                    v-for="option in options"
                    :key="option.value"
                    :value="option.value"
                  >
                    {{ option.text }}
                  </option>
                </select>
              </div>
              <div class="col-lg-2 col-md-6">
                <label class="form-label">Código do CCusto:</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder="Código do CCusto"
                  v-model="client.codCCusto"
                />
              </div>
              <div class="col-lg-4 col-md-6">
                <label class="form-label">Nome do CCusto:</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder="Nome do CCusto"
                  v-model="client.nomeCCusto"
                />
              </div>
              <div class="col-lg-3 col-md-6">
                <label class="form-label">
                  Tipo de Escopo: <span class="text-danger">*</span>
                </label>
                <input
                  type="text"
                  class="form-control"
                  :class="{ 'is-invalid': v$.client.tipoEscopo.$errors.length }"
                  placeholder="Tipo de Escopo"
                  v-model="v$.client.tipoEscopo.$model"
                />
                <span
                  v-if="
                    v$.client.tipoEscopo.required.$invalid &&
                    v$.client.tipoEscopo.$errors.length
                  "
                  class="invalid-feedback"
                >
                  O campo é obrigatório
                </span>
              </div>
              <div class="col-lg-3 col-md-6">
                <label class="form-label">
                  Tipo de Projeto: <span class="text-danger">*</span>
                </label>
                <input
                  type="text"
                  class="form-control"
                  :class="{
                    'is-invalid': v$.client.tipoProjeto.$errors.length,
                  }"
                  placeholder="Tipo de Projeto"
                  v-model="v$.client.tipoProjeto.$model"
                />
                <span
                  v-if="
                    v$.client.tipoProjeto.required.$invalid &&
                    v$.client.tipoProjeto.$errors.length
                  "
                  class="invalid-feedback"
                >
                  O campo é obrigatório
                </span>
              </div>
              <div class="col-lg-2 col-md-6">
                <label class="form-label">
                  Franquia: <span class="text-danger">*</span>
                </label>
                <select class="form-select" v-model="v$.client.franquia.$model">
                  <option value="" disabled>Selecione</option>
                  <option
                    v-for="option in options"
                    :key="option.value"
                    :value="option.value"
                  >
                    {{ option.text }}
                  </option>
                </select>
              </div>
              <div class="col-lg-2 col-md-6">
                <label class="form-label">
                  Horas por Mês:
                  <span class="text-danger">*</span>
                </label>
                <input
                  type="number"
                  class="form-control"
                  :class="{
                    'is-invalid': v$.client.horasPorMes.$errors.length,
                  }"
                  placeholder="Horas por mês"
                  v-model="v$.client.horasPorMes.$model"
                />
                <span
                  v-if="
                    v$.client.horasPorMes.required.$invalid &&
                    v$.client.horasPorMes.$errors.length
                  "
                  class="invalid-feedback"
                >
                  O campo é obrigatório
                </span>
              </div>
              <div class="col-lg-2 col-md-6">
                <label class="form-label">
                  Valor Hora:
                  <span class="text-danger">*</span>
                </label>
                <input
                  type="number"
                  class="form-control"
                  :class="{
                    'is-invalid': v$.client.valorHoraAdicional.$errors.length,
                  }"
                  placeholder="Valor Hora"
                  step="0.01"
                  v-model="v$.client.valorHoraAdicional.$model"
                />
                <span
                  v-if="
                    v$.client.valorHoraAdicional.required.$invalid &&
                    v$.client.valorHoraAdicional.$errors.length
                  "
                  class="invalid-feedback"
                >
                  O campo é obrigatório
                </span>
              </div>
              <div class="col-lg-3 col-md-6">
                <label class="form-label">
                  Franquia Acumulada: <span class="text-danger">*</span>
                </label>
                <select
                  class="form-select"
                  v-model="v$.client.franquiaAcumulada.$model"
                >
                  <option value="" disabled>Selecione</option>
                  <option
                    v-for="option in options"
                    :key="option.value"
                    :value="option.value"
                  >
                    {{ option.text }}
                  </option>
                </select>
              </div>
              <div class="col-lg-3 col-md-6">
                <label class="form-label">
                  Período Acumulado:
                  <span class="text-danger">*</span>
                </label>
                <input
                  type="number"
                  class="form-control"
                  :class="{
                    'is-invalid': v$.client.periodoAcumulado.$errors.length,
                  }"
                  placeholder="Período Acumulado"
                  v-model="v$.client.periodoAcumulado.$model"
                />
                <span
                  v-if="
                    v$.client.periodoAcumulado.required.$invalid &&
                    v$.client.periodoAcumulado.$errors.length
                  "
                  class="invalid-feedback"
                >
                  O campo é obrigatório
                </span>
              </div>
              <div class="col-lg-3 col-md-6">
                <label class="form-label">
                  Percentual Franquia Acumulada:
                  <span class="text-danger">*</span>
                </label>
                <input
                  type="number"
                  class="form-control"
                  :class="{
                    'is-invalid':
                      v$.client.percentualFranquiaAcumulada.$errors.length,
                  }"
                  placeholder="Percentual Franquia Acumulada"
                  v-model="v$.client.percentualFranquiaAcumulada.$model"
                />
                <span
                  v-if="
                    v$.client.percentualFranquiaAcumulada.required.$invalid &&
                    v$.client.percentualFranquiaAcumulada.$errors.length
                  "
                  class="invalid-feedback"
                >
                  O campo é obrigatório
                </span>
              </div>
            </div>
          </div>
          <div class="modal-footer border-top-0">
            <button
              type="button"
              class="btn btn-link"
              data-bs-dismiss="modal"
              title="Cancelar"
              @click="$emit('closeModal', false)"
            >
              Cancelar
            </button>
            <button
              type="submit"
              class="btn btn-primary"
              :title="textModal"
              :disabled="v$.$invalid || disableButton"
            >
              <span v-if="disableButton">
                <i class="ph ph-spinner spinner" />
              </span>
              <span v-else>{{ textModal }}</span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { useVuelidate } from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import { showModal, hideModal } from '@/utils/modal'
import {
  parseTimeFromSeconds,
  convertHoursToSeconds,
  convertSecondsToHours,
} from '@/utils/date'

export default {
  name: 'CreateEditClientModal',

  props: {
    clientId: {
      type: String,
      default: null,
    },
  },

  setup() {
    return { v$: useVuelidate() }
  },

  data() {
    return {
      client: {
        codColigada: 1,
        codCliente: '',
        codProjeto: '',
        nome: '',
        descricao: '',
        email: '',
        codCCusto: '',
        nomeCCusto: '',
        tipoEscopo: '',
        tipoProjeto: '',
        franquia: '',
        horasPorMes: '',
        valorHoraAdicional: '',
        franquiaAcumulada: '',
        periodoAcumulado: '',
        percentualFranquiaAcumulada: '',
        default: '',
        status: '',
      },
      options: [
        { value: 1, text: 'Sim' },
        { value: 0, text: 'Não' },
      ],
      optionsStatus: [
        { value: 1, text: 'Ativo' },
        { value: 0, text: 'Inativo' },
      ],
      disableButton: false,
      convertSecondsToHours,
    }
  },

  computed: {
    textModal() {
      return this.clientId ? 'Atualizar' : 'Cadastrar'
    },
  },

  methods: {
    async getClient() {
      try {
        const client = await this.$store.dispatch('getClient', {
          clienteId: this.clientId,
        })

        const { hours } = parseTimeFromSeconds(client.horasPorMes)
        this.client = { ...client, horasPorMes: hours }

        showModal('modalCreateEditClient')
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
        this.$emit('closeModal', false)
      }
    },

    async save() {
      if (!this.v$.$invalid) {
        this.disableButton = true
        try {
          const client = {
            ...this.client,
            horasPorMes: convertHoursToSeconds(this.client.horasPorMes),
          }

          let response = null

          if (this.clientId) {
            response = await this.$store.dispatch('updateClient', {
              id: this.clientId,
              client,
            })
          } else {
            response = await this.$store.dispatch('createClient', client)
          }

          hideModal()
          this.$emit('closeModal', true)
          this.$root.$refs.notification.success(response.message)
        } catch (error) {
          this.disableButton = false
          if (error && error.message) {
            this.$root.$refs.notification.warning(error.message)
          } else {
            this.$root.$refs.notification.error(
              'Não foi possível se conectar ao servidor.',
            )
          }
        }
      }
    },
  },

  validations() {
    return {
      client: {
        codCliente: {
          required,
        },
        codProjeto: {
          required,
        },
        nome: {
          required,
        },
        descricao: {
          required,
        },
        tipoEscopo: {
          required,
        },
        tipoProjeto: {
          required,
        },
        franquia: {
          required,
        },
        horasPorMes: {
          required,
        },
        valorHoraAdicional: {
          required,
        },
        franquiaAcumulada: {
          required,
        },
        periodoAcumulado: {
          required,
        },
        percentualFranquiaAcumulada: {
          required,
        },
        default: {
          required,
        },
        status: {
          required,
        },
      },
    }
  },

  mounted() {
    if (this.clientId) {
      this.getClient()
    } else {
      showModal('modalCreateEditClient')
    }
  },
}
</script>
